<template>
<span>
	<a class="ui-btn" v-show="show" @click="onCodeClick">获取验证码</a>
	<span class="ui-btn ui-btn-disable" v-show="!show">{{codeNum + '秒后重试'}}</span>
	<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
	<tips-auto v-show="tipsauto" :tipsFont="tipsFont"></tips-auto>
</span>
</template>

<script>
var tid = 0
import Tips from '../components/Tips'
import TipsAuto from '../components/TipsAuto'
export default {
	props: {
		mobile: String,
		type: Number,
		verifyCode: String,
		uuid: String
	},
	data () {
		return {
			show: true,
			tips: false,
			tipsauto: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			code: '',
			codeNum: 0,
			codeDisable: false,
			// patrn: /^(((13[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/,
			patrn: /^([0-9]{11})$/,
			sec: 1500
		}
	},
	components: {
		'tips': Tips,
		'tips-auto': TipsAuto
	},
	methods: {
		tipStatus (msg) {
			this.tips = msg[0]
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		// {{{ countDown
		countDown () {
			this.codeDisable = true
			tid = setInterval(() => {
				if (--this.codeNum === 0) {
					this.show = true
					clearInterval(tid)
				}
			}, 1000)
		},
		// }}}
		// {{{ onCodeClick
		onCodeClick () {
			if (this.codeNum > 0) {
				return
			}
			if (this.mobile === '') {
				this.autoTips('手机号码不能为空')
				return false
			} else if (!this.patrn.test(this.mobile)) {
				this.autoTips('手机号码格式不正确')
				return false
			} else if (this.verifyCode === '') {
				this.autoTips('图形验证码不能为空')
				return false
			}
			var filter = {type: this.type, data: this.mobile, verifyCode: this.verifyCode, uuid: this.uuid}
			this.show = false
			this.codeNum = 60
			this.$http.post('/cldEdi/business/vCode/get', filter).then(res => {
				var data = res.body
				if (!data.result) {
					this.autoTips(data.message)
					this.$emit('on-refresh')
					return Promise.reject()
				}
				this.countDown()
			}).catch(() => {
				clearInterval(tid)
				this.show = true
				this.codeNum = 0
			})
		}
		// }}}
	}
}
</script>



// WEBPACK FOOTER //
// MobileCode.vue?d9466dec